import { Grid } from "@mui/material";
import React from "react";
import Box from "ReusableComponents/Box";
import H2 from "ReusableComponents/Text/H2";
import { COLORS, SIZES } from "theme";
import Text from "ReusableComponents/Text";

const BlogSection = ({ small, blogs, ourBlogTitle }) => {


  return (
    <Grid
      container
      spacing={2}
      style={{
        width: "auto",
        padding: small ? "0px" : "24px",
        marginLeft: small ? "0px" : "50px",
        marginRight: small ? "0px" : "50px",
      }}
    >
      <Grid item xs={12}>
        <Box textAlign="center" display="flex" flexDirection="column">
          <H2
            textColor="white"
            fontWeight="bold"
            fontSize={small ? SIZES.twenty : "40px"}
            margin="16px 0"
          >
            {ourBlogTitle?.attributes?.title}
          </H2>
          <Box
            w={small ? "100%" : "600px"}
            margin="10px auto"
            padding={small ? "0px 5px" : "0px"}
          >
            <p
              style={{
                color: COLORS.white,
                fontSize: small ? SIZES.sizteen : "17px",
                margin: "0",
              }}
            >
              {ourBlogTitle?.attributes?.description}
            </p>
          </Box>
        </Box>
      </Grid>
      {blogs?.map((blog, index) => (
        <Grid item xs={12} sm={6} md={3} key={index} padding={"10px 20px"}>
          <Box>
            <img
              src={
                blog?.attributes?.featured_media?.data?.attributes?.url
              }
              alt={blog?.attributes?.title}
              style={{ width: "100%" }}
            />
            <Text
              textColor={COLORS.white}
              fontWeight={"w800"}
              fontSize={small ? SIZES.sizteen : "18px"}
              margin="16px 0 8px"
            >
              {blog?.attributes?.title}
            </Text>
            <p
              style={{
                color: COLORS.lightGrey,
                fontSize: small ? SIZES.fourteen : "13px",
                marginBottom: small && "10px",
              }}
            >
              {blog?.attributes?.description}
            </p>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default BlogSection;
